import { decode } from './decode';

import type { PoiInfo } from '../interfaces';
import { MAP_API_PATH } from '../poiConfig';

export const TransportPopup = ({ name, objectId, typeName, iconUrl }: PoiInfo) => (
    <div className="poiPopupContent">
        <div className="entur-popup">
            <div className="station">
                <img className="type-icon" src={iconUrl} alt={decode(typeName)} />
                <span className="name">{decode(name)}</span>

                <div className="entur-logo">
                    <a
                        target="_blank"
                        href={`https://en-tur.no/nearby-stop-place-detail?id=NSR:StopPlace:${objectId}`}
                        className="click-log"
                        data-typeid="100100"
                        data-objectid={objectId}
                        data-logtype="2"
                        rel="noreferrer">
                        <img src={`${MAP_API_PATH}/images/entur/entur.svg`} alt={'Entur logo'} />
                    </a>
                </div>

                <nav className="entur-links">
                    <p className="navigation">
                        <a
                            target="_blank"
                            href={`https://en-tur.no/travel-result?stopId=NSR:StopPlace:${objectId}`}
                            className="click-log"
                            data-typeid="100100"
                            data-objectid={objectId}
                            data-logtype="2"
                            rel="noreferrer">
                            Reis til
                        </a>
                    </p>
                    <p className="navigation">
                        <a
                            target="_blank"
                            href={`https://en-tur.no/travel-result?startId=NSR:StopPlace:${objectId}`}
                            className="click-log"
                            data-typeid="100100"
                            data-objectid={objectId}
                            data-logtype="2"
                            rel="noreferrer">
                            Reis fra
                        </a>
                    </p>
                    <p className="navigation">
                        <a
                            target="_blank"
                            href={`https://en-tur.no/nearby-stop-place-detail?id=NSR:StopPlace:${objectId}`}
                            className="click-log"
                            data-typeid="100100"
                            data-objectid={objectId}
                            data-logtype="2"
                            rel="noreferrer">
                            Alle avganger
                        </a>
                    </p>
                </nav>
            </div>
        </div>
    </div>
);
